import { render, staticRenderFns } from "./CardTagihan.vue?vue&type=template&id=a55499ce&scoped=true&"
import script from "./CardTagihan.vue?vue&type=script&lang=js&"
export * from "./CardTagihan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55499ce",
  null
  
)

export default component.exports